import _ from "lodash";
import { getMemoizedLangFunction, getMemoizedFunction } from "Utils";

// there are three different types of cards and each one
// has to be styled conditionally
export const CARD_TYPES = {
  ASSOCIATED_UNITS: "associatedUnits",
  ASSOCIATED_TASKS: "associatedTasks",
  LE_POPOVER: "lePopover",
};

const getInsightDataGroupedBySubjectGroups = ({ coveredUnitPlans }) => {
  const groupedInsightData = [];

  _.forEach(coveredUnitPlans, unitPlan => {
    const subjectGroups = _.get(
      _.find(_.get(unitPlan, "fields", []), { uid: "subjectGroup" }),
      "resolvedMinimalTree.subjectGroups"
    );
    _.forEach(subjectGroups, subjectGroup => {
      const unitPlansOfSubjectGroup = _.find(groupedInsightData, {
        subjectGroup: subjectGroup?.name,
      });
      if (!unitPlansOfSubjectGroup) {
        groupedInsightData.push({
          id: subjectGroup?.id,
          subjectGroup: _.get(subjectGroup, "name", ""),
          unitPlans: [unitPlan],
        });
      } else {
        unitPlansOfSubjectGroup.unitPlans.push(unitPlan);
      }
    });
  });

  return groupedInsightData;
};

const getInsightCountData = ({
  isTasksOrQuestions,
  coveredAssessments,
  coveredUnitPlans,
  fetchSubjectGroups,
}) => {
  if (isTasksOrQuestions) return coveredAssessments;

  return fetchSubjectGroups
    ? getInsightDataGroupedBySubjectGroups({ coveredUnitPlans })
    : coveredUnitPlans;
};

export const getInsightCountDataMemoized = getMemoizedFunction(
  getInsightCountData
);

const getModalTitle = ({
  t,
  isCurriculumPYP,
  displayType,
  nodeLabel,
  showModalWithInsightsCount,
}) => {
  switch (displayType) {
    case "UNIT_PLANS": {
      // for PYP, we show "Units associated to {element}"
      return showModalWithInsightsCount && !isCurriculumPYP
        ? t("common:associated_units")
        : t("common:associated_units_modal_with_insights_count_heading", {
            label: nodeLabel,
          });
    }

    case "ASSESSMENTS": {
      return t("common:associated_tasks");
    }

    case "WORKSHEETS": {
      return t("planningInsights:questions_associated_to_label", {
        label: nodeLabel,
      });
    }
  }
};

export const getModalTitleMemoized = getMemoizedLangFunction(getModalTitle);
